import { LockIcon, neutral } from '@bloomfieldrobotics/canopy';
import {
  ToggleButton,
  toggleButtonClasses,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
} from '@mui/material';
import { CountMode } from '../../components/ReportBarChart/types';
import { useCountModeLabels } from '../hooks/useCountModeLabels';

type Props = {
  countMode: CountMode;
  onCountModeChange: (countMode: CountMode) => void;
  options: {
    countMode: CountMode;
    disabled?: boolean;
  }[];
};
export const CountModeToggleButtonGroup = ({
  countMode,
  onCountModeChange,
  options,
}: Props) => {
  const countModeLabels = useCountModeLabels();

  return (
    <ToggleButtonGroup
      value={countMode}
      exclusive
      onChange={(_, newMode) => {
        if (newMode !== null) {
          onCountModeChange(newMode);
        }
      }}
      aria-label='Count mode selection'
      sx={{
        alignSelf: 'center',
        backgroundColor: neutral[1000],
        borderRadius: 1.75,
        padding: 1,
        gap: 2,
        [`& .${toggleButtonGroupClasses.grouped}`]: {
          [`&.${toggleButtonGroupClasses.disabled}`]: {
            border: 'none',
          },
          [`&.${toggleButtonClasses.root}`]: {
            textTransform: 'none',
            border: 'none',
            borderRadius: 1.5,
            padding: '0.375rem 0.75rem',
            [`&:not(.${toggleButtonClasses.selected})`]: {
              color: 'text.secondary',
            },
          },
        },
      }}
    >
      {options.map(({ countMode, disabled }) => (
        <ToggleButton key={countMode} value={countMode} disabled={disabled}>
          {countModeLabels[countMode]}
          {disabled && <LockIcon sx={{ ml: 1, fontSize: '0.75rem' }} />}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
